import { mapTeamPlayerToTournamentUser } from 'modules/teams/domain/data-mappers/team-player.data-mapper';
import { EntryRequest } from 'modules/teams/domain/interfaces/entry-request';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { TournamentUser } from 'modules/teams/domain/interfaces/tournament-user';

/**
 * Новые сверху. Порядок задавал слайс players при записи в стор; теперь он живёт
 * рядом с разбиением по вкладкам, чтобы источник данных на него не влиял.
 */
const byNewestFirst = (a: TeamPlayer, b: TeamPlayer) => b.id - a.id;

/** «Игроки» — записи состава, заведённые организатором вручную. */
export const selectSquad = (players: TeamPlayer[] = []): TeamPlayer[] => players.filter((player) => !player.isReal).sort(byNewestFirst);

/** «Участники» — реальные пользователи, вступившие в команду. */
export const selectParticipants = (players: TeamPlayer[] = []): TournamentUser[] =>
  players
    .filter((player) => player.isReal)
    .sort(byNewestFirst)
    .map(mapTeamPlayerToTournamentUser);

/** «Лист ожидания» — только заявки, по которым ещё нет решения. */
export const selectWaitingList = (entryRequests: EntryRequest[] = []): EntryRequest[] =>
  entryRequests.filter((entryRequest) => entryRequest.status === 'CREATED');
